<template>
  <va-edit-layout :title="title">
    <template #actions>
      <va-create-button></va-create-button>
    </template>
    <contributors-form :id="id" :title="title" :item="item"></contributors-form>
  </va-edit-layout>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    item: {
      type: Object,
      default: null,
    },
  },
};
</script>
